import { useEffect } from 'react';
import { useRevealOnScroll } from '@/hooks/useScrollReveal';
import { Link } from 'react-router-dom';

const fleet = [
  {
    type: 'Kargo Uçakları',
    icon: 'ri-plane-line',
    count: '15+',
    desc: 'Partner hava kargo kapasitesi',
    features: ['Boeing 737 Freighter', 'Airbus A320F', '150+ haftalık uçuş', 'Gece uçuşu kapasitesi'],
    img: 'https://readdy.ai/api/search-image?query=cargo%20airplane%20on%20runway%20at%20night%20airport%20orange%20runway%20lights%20dramatic%20sky%20professional%20aviation%20photography%20wide%20angle&width=600&height=400&seq=fleet3-air&orientation=landscape',
  },
  {
    type: 'Karayolu Filomuz',
    icon: 'ri-truck-line',
    count: '85+',
    desc: 'Euro 6 GPS takipli araç',
    features: ['Mercedes Actros', 'Volvo FH Series', 'Soğuk zincir donanımlı', 'Euro 6 emisyon'],
    img: 'https://readdy.ai/api/search-image?query=modern%20cargo%20truck%20fleet%20on%20highway%20at%20sunset%20orange%20sky%20professional%20transportation%20photography%20cinematic%20wide%20angle&width=600&height=400&seq=fleet3-truck&orientation=landscape',
  },
  {
    type: 'Konteyner Hatları',
    icon: 'ri-ship-2-line',
    count: '50+',
    desc: 'Dünya limanlarına doğrudan hat',
    features: ['20ft ve 40ft konteyner', 'Soğutmalı konteyner', 'Haftalık seferler', 'FCL/LCL seçenekleri'],
    img: 'https://readdy.ai/api/search-image?query=container%20ship%20at%20sea%20golden%20hour%20sunset%20orange%20light%20reflecting%20water%20professional%20maritime%20photography%20cinematic&width=600&height=400&seq=fleet3-ship&orientation=landscape',
  },
  {
    type: 'Fulfillment Deposu',
    icon: 'ri-building-2-line',
    count: '5.000 m²',
    desc: 'İklim kontrollü fulfillment',
    features: ['Esenyurt İstanbul', 'İklim kontrollü', 'CCTV güvenlik', 'Otomatik konveyör'],
    img: 'https://readdy.ai/api/search-image?query=modern%20warehouse%20fulfillment%20center%20interior%20workers%20conveyor%20belt%20orange%20accent%20lighting%20professional%20wide%20angle%20photography&width=600&height=400&seq=fleet3-wh&orientation=landscape',
  },
];

const tech = [
  { icon: 'ri-radar-line', title: 'Anlık GPS Takip', desc: 'Tüm araçlar GPS donanımlı. Web ve WhatsApp üzerinden canlı konum takibi.' },
  { icon: 'ri-robot-line', title: 'AI Rota Motoru', desc: 'Yapay zeka ile en hızlı ve ekonomik rota otomatik belirleniyor.' },
  { icon: 'ri-qr-code-line', title: 'QR Barkod Sistemi', desc: 'Her paket benzersiz QR ile depodan teslimat kapısına kadar izleniyor.' },
  { icon: 'ri-cloud-line', title: 'Bulut Platform', desc: 'Tüm kargo verileri güvenli bulutta. Her cihazdan 7/24 erişim imkânı.' },
  { icon: 'ri-notification-3-line', title: 'Akıllı Bildirim', desc: 'SMS ve e-posta ile otomatik durum güncellemeleri alıcıya iletiliyor.' },
  { icon: 'ri-link-m', title: 'API Entegrasyonu', desc: 'E-ticaret ve ERP sistemlerinizi CargoNet\'e kolayca bağlayın.' },
];

const techStats = [
  { v: '99.8%', l: 'Teslimat Başarısı' },
  { v: '24/7', l: 'Sistem Çalışma Süresi' },
  { v: '3 dk', l: 'Ortalama Yanıt Süresi' },
  { v: '256-bit', l: 'SSL Güvenlik' },
];

export default function FleetPage() {
  useRevealOnScroll();
  useEffect(() => {
    document.title = 'Filo & Teknoloji | CargoNet – Modern Lojistik Altyapısı';
    window.scrollTo(0, 0);
  }, []);

  return (
    <main style={{ background: 'var(--bg)', color: 'var(--text1)' }}>

      {/* ── HERO ── */}
      <section className="relative pt-36 pb-24 overflow-hidden" style={{ background: 'var(--bg)' }}>
        <div className="absolute inset-0 pointer-events-none">
          <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
          <div style={{ position: 'absolute', top: '-200px', right: '-150px', width: 600, height: 600, background: 'radial-gradient(circle, var(--glow2) 0%, transparent 65%)', borderRadius: '50%' }} />
          <div style={{ position: 'absolute', bottom: 0, left: '-20%', right: '-20%', height: '40%', backgroundImage: 'linear-gradient(var(--grid-color) 1px, transparent 1px), linear-gradient(90deg, var(--grid-color) 1px, transparent 1px)', backgroundSize: '50px 50px', transform: 'perspective(600px) rotateX(62deg)', transformOrigin: 'bottom', maskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)', WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 80%)' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="label"><div className="label-dot" />Filo & Teknoloji</div>
              <h1
                className="h-font leading-[0.95] mb-6"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(46px,6vw,80px)', color: 'var(--text1)' }}
              >
                Modern Filo,<br /><span className="text-gradient">Akıllı Teknoloji.</span>
              </h1>
              <p style={{ fontSize: 18, color: 'var(--text2)', maxWidth: 440, lineHeight: 1.75, marginBottom: 36 }}>
                Euro 6 karayolu filosu, küresel hava kargo ağı ve AI destekli platformumuzla sektörün önünde yürüyoruz.
              </p>
              <div className="flex flex-wrap gap-3">
                <Link to="/iletisim" className="btn-primary cursor-pointer">
                  Demo Talep Et <i className="ri-arrow-right-line bounce-x" />
                </Link>
                <Link to="/hizmetler" className="btn-ghost cursor-pointer">
                  Hizmetleri İncele
                </Link>
              </div>
            </div>
            <div className="reveal-r relative">
              <div className="relative rounded-3xl overflow-hidden grad-border" style={{ aspectRatio: '4/3' }}>
                <img
                  src="https://readdy.ai/api/search-image?query=logistics%20control%20center%20multiple%20screens%20world%20map%20tracking%20system%20professional%20office%20orange%20accent%20lighting%20cinematic%20wide%20angle&width=700&height=530&seq=fleet3-hero&orientation=landscape"
                  alt="CargoNet Teknoloji Merkezi"
                  className="w-full h-full object-cover"
                />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, var(--overlay-mid) 0%, transparent 60%)' }} />
              </div>
              <div
                className="glass absolute -bottom-5 -right-5 flex items-center gap-3 px-5 py-4 rounded-2xl float-y"
                style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.3)' }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl" style={{ background: 'rgba(232,97,26,0.2)', border: '1px solid rgba(232,97,26,0.3)' }}>
                  <i className="ri-truck-line text-[#E8611A]" />
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 22, color: 'var(--text1)' }}>85+ Araç</div>
                  <div style={{ fontSize: 13, color: 'var(--text3)' }}>GPS Takipli Filo</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FLEET CARDS ── */}
      <section style={{ background: 'var(--bg2)', padding: '96px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="text-center max-w-xl mx-auto mb-16">
            <div className="label inline-flex"><div className="label-dot" />Filomuz</div>
            <h2
              className="reveal h-font leading-[1.1]"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
            >
              Altyapı <span className="text-gradient">Gücümüz</span>
            </h2>
            <p className="reveal d2 mt-4" style={{ fontSize: 16, color: 'var(--text2)', lineHeight: 1.7 }}>
              Hava, kara ve denizde güçlü bir ağ. Her türlü kargo için doğru araç, doğru rota.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {fleet.map((item, i) => (
              <div key={i} className={`reveal d${i + 1} card-dark overflow-hidden rounded-3xl`}>
                <div style={{ height: 240, position: 'relative', overflow: 'hidden' }}>
                  <img src={item.img} alt={item.type} className="w-full h-full object-cover" />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, var(--overlay-dark) 0%, transparent 55%)' }} />
                  <div className="absolute bottom-4 left-4">
                    <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 36, lineHeight: 1, color: '#fff' }}>{item.count}</div>
                    <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>{item.desc}</div>
                  </div>
                  <div
                    className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-xl"
                    style={{ background: '#E8611A', boxShadow: '0 0 20px rgba(232,97,26,0.5)' }}
                  >
                    <i className={`${item.icon} text-white text-base`} />
                  </div>
                </div>
                <div className="p-7">
                  <h3 style={{ fontWeight: 800, fontSize: 18, color: 'var(--text1)', marginBottom: 14 }}>{item.type}</h3>
                  <div className="grid grid-cols-2 gap-2.5">
                    {item.features.map((f, j) => (
                      <div key={j} className="flex items-center gap-2" style={{ color: 'var(--text2)', fontSize: 13 }}>
                        <div
                          className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0"
                          style={{ background: 'rgba(232,97,26,0.15)', border: '1px solid rgba(232,97,26,0.25)' }}
                        >
                          <i className="ri-check-line text-[#E8611A]" style={{ fontSize: 10 }} />
                        </div>
                        {f}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TECH ── */}
      <section style={{ background: 'var(--bg)', padding: '96px 0', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="label"><div className="label-dot" />Teknoloji</div>
              <h2
                className="reveal h-font leading-[1.1] mb-5"
                style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px,4.5vw,52px)', color: 'var(--text1)' }}
              >
                Lojistiğin<br /><span className="text-gradient">Dijital Kalbi</span>
              </h2>
              <p className="reveal d2 text-base leading-relaxed mb-8" style={{ color: 'var(--text2)', maxWidth: 420 }}>
                Özel geliştirdiğimiz platform, her kargo adımını izliyor, optimize ediyor ve müşterilerimize şeffaf bir deneyim sunuyor.
              </p>
              <Link to="/iletisim" className="reveal d3 btn-primary cursor-pointer">
                Demo Talep Et <i className="ri-arrow-right-line bounce-x" />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {tech.map((t, i) => (
                <div key={i} className={`reveal d${Math.min(i + 1, 6)} card-dark p-6`}>
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl mb-4"
                    style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.2)' }}
                  >
                    <i className={`${t.icon} text-[#E8611A] text-lg`} />
                  </div>
                  <h3 style={{ fontWeight: 800, fontSize: 14, color: 'var(--text1)', marginBottom: 6 }}>{t.title}</h3>
                  <p style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.65 }}>{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS BAR ── */}
      <section style={{ background: '#E8611A', padding: '64px 20px' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {techStats.map((s, i) => (
              <div key={i}>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(28px,4vw,48px)', color: '#fff', lineHeight: 1 }}>{s.v}</div>
                <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)', fontWeight: 500, marginTop: 8 }}>{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ background: 'var(--bg2)', padding: '80px 20px', borderTop: '1px solid var(--border)' }}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h2 style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(24px,3vw,40px)', color: 'var(--text1)', marginBottom: 8 }}>
              Teknolojimizi yakından görmek ister misiniz?
            </h2>
            <p style={{ color: 'var(--text2)', fontSize: 16, lineHeight: 1.6 }}>
              Demo talep edin, ekibimiz size özel bir sunum hazırlasın.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 flex-shrink-0">
            <Link to="/iletisim" className="btn-primary cursor-pointer whitespace-nowrap">
              Demo Talep Et <i className="ri-arrow-right-line bounce-x" />
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}
